export default [
    {
        // 图标解释标题
        title:$t('integration.display_type_icon'),
        // 图标类型
        type:"displayscreenType", 
    },
    {
        title:$t('integration.display_status_icon'),
        type:'equiStatus'
    },
    {
        title:$t('integration.configuration_status_icon'),
        type:'configStatus'
    }
]